// extracted by mini-css-extract-plugin
module.exports = {"stack":"stack_stack__mLaL1","recursive":"stack_recursive__wE9Yw"};